import { isArray, isNil } from 'lodash'
import { HttpError } from './requestsUtils'
import { AxiosError } from 'axios'
import { NextResponse } from 'next/server'
import { AccessTokenError } from '@auth0/nextjs-auth0/errors'

interface Options {
    fileKey: string
}

export const convertObjectToFormData = (value: Record<any, any>, options?: Options): FormData => {
    const formData = new FormData()

    const resolveAppend = (key: any, value: any) => {
        options?.fileKey && value instanceof File
            ? formData.append(options?.fileKey, value)
            : formData.append(key, value)
    }

    Object.entries(value).forEach(([key, value]) => {
        if (!isNil(value)) {
            isArray(value) ? value.map((item) => resolveAppend(key, item)) : resolveAppend(key, value)
        }
    })

    return formData
}

export const getClientErrorMessage = (error: unknown): string | undefined =>
    error instanceof HttpError ? error.message : undefined

export const handleApiError = (error: unknown): Response => {
    if (error instanceof HttpError || error instanceof AxiosError) {
        return NextResponse.json({ error: error.message }, { status: error.status ?? 500 })
    } else if (error instanceof AccessTokenError) {
        return NextResponse.json({ code: 'ACCESS_TOKEN_ERROR' }, { status: 401 })
    } else if (error instanceof Error) {
        return NextResponse.json({ error: error.message }, { status: 500 })
    } else {
        return NextResponse.json({ error }, { status: 500 })
    }
}
